// --- src/pages/candidate/profile/ProfileLandingPage.jsx ---
import { NavLink } from "react-router-dom"

export function CandidateProfileLandingPage() {
    const sections = [
        { label: "Personal Info", path: "personal" },
        { label: "Compliance Documents", path: "compliance" },
        { label: "Agreements", path: "terms" },
        { label: "CV", path: "cv" },
        { label: "Questionnaire", path: "questions" },
    ]

    return (
        <div className="flex flex-col grow min-h-[calc(100vh-5rem)] p-6 space-y-6">
            <h1 className="text-2xl font-bold">My Profile</h1>
            <div className="grid gap-4 sm:grid-cols-2">
                {sections.map(({ label, path }) => (
                    <NavLink
                        key={path}
                        to={path}
                        className="block p-4 border rounded-2xl shadow-sm hover:shadow-md transition hover:bg-muted"
                    >
                        <div className="font-semibold text-lg">{label}</div>
                    </NavLink>
                ))}
            </div>
        </div>
    )
}
